module.exports = __webpack_public_path__ + "icon_kayttaja.9eda59c076c6d194ff9b.svg";